import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { SendFromOptionIcon } from './send_from_option_icon';
const containerCss = "c1m0nn7v";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const emailAddressCondensedCss = "e16z55g1";
const EmailAddressCondensed = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(emailAddressCondensedCss, props.className)} />;
});
export const SendFromOption = ({
  option,
  withReconnect = false,
  minimized = false
}) => <Container>
    <SendFromOptionIcon option={option} />
    {!minimized && <EmailAddressCondensed>{option.name || option.emailAddress}</EmailAddressCondensed>}
    {!option.accessGranted && withReconnect && <Button as="a" size="small" href={`/integrations/${option.type}`} aria-label={`${option.type}-reconnect-button`} target="_blank" rel="noopener noreferrer">
        {I18n.t('publisher.send_from_calendly.action.reconnect')}
      </Button>}
  </Container>;
export const SendFromEmptyOption = ({
  minimized = false
}) => <Container>
    {!minimized && <EmailAddressCondensed>
        {I18n.t('publisher.send_from_calendly.send_with_dropdown.unselected_state')}
      </EmailAddressCondensed>}
  </Container>;

require("./send_from_option.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./send_from_option.js");